@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.dropdown-display {
  overflow: unset;

  .danger {
    color: @settings-page--templates-packing-slips-dropdown--error--text-color;
  }
}

.nested {
  overflow: unset;
  height: 35px;
}

.nested-anchor {
  svg {
    height: 16px;
    width: 16px;
    position: relative;
    top: 3px;
    right: -4px;
  }
}

.actions-dropdown {
  background-color: @settings-page--templates-packing-slips-action-dropdown--background-color;
  border: none;
  height: 100%;

  &:hover {
    background-color: @settings-page--templates-packing-slip-action-dropdown--hover--background-color;
  }
}

.icon-wrapper {
  color: @settings-page--templates-packing-slips-icon--text-color;
  cursor: pointer;

  &:hover {
    color: @settings-page--templates-packing-slips-icon--hover--text-color;
  }

  svg {
    width: 16px;
  }
}

.icon-open {
  .icon-wrapper {
    color: @settings-page--templates-packing-slips-icon-open--text-color;

    &:hover {
      color: @settings-page--templates-packing-slips-icon--hover--text-color;
    }
  }
}

.overlay-wrapper {
  box-shadow: 1px 1px 3px @settings-page--templates-packing-slips-overlay--box-shadow-color;
  overflow-y: auto;
  width: auto;
}
